var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"htmldiv bgw topdiv"},[_c('router-link',{attrs:{"to":"/zedu/index"}},[_c('img',{attrs:{"src":require("../../assets/images/index_01_12.png")}})]),_vm._v(" "),_c('router-link',{staticStyle:{"float":"right","margin-top":"60px"},attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../assets/images/go_home.jpg")}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60781816","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zedu/top.vue
// module id = null
// module chunks = 